export const isSystemLabel = (labelType: string) => labelType === "preset";
